import { Outlet } from 'react-router-dom';
import { TopNav } from '@/components/layout/TopNav';

export function MarketingLayout() {
  return (
    <div className="min-h-screen">
      <TopNav />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
